/* eslint-disable */
export default function (_this) {
  return {
    create (data, callback) {
      let widget = {
        title: data.title,
        classes: data.classes,
        template: data.template,
        gsOptions: {
          x: 0,
          y: 0,
          w: data.w,
          h: data.h
        },
        tab: data.tab
      }

      let key = _this.getRef('widgets').push(widget, () => {
        callback(key)
      }).key
    },
    read (callback) {
      _this.getRef('widgets').on('value', (snapshot) => {
        let data = snapshot.val() || []
        if (snapshot.val()) {
          let widgets = data
          for (let key in widgets) {
            widgets[key]['.key'] = key
          }
          data = Object.values(widgets)
          widgets = null
        }
        callback(data)
      })
    },
    readData (callback) {
      _this.getRef('widgetsData').on('value', (snapshot) => {
        let data = snapshot.val() || {}
        callback(data)
      })
    },
    updateData (newData, callback) {
      _this.getRef('widgetsData').set(newData, (err) => {
        if (err) callback(err)
        else callback(null)
      })
    },
    readDataByPath (path, callback) {
      let ref = _this.getRef('widgetsData')
      if (path) ref = _this.getRef('widgetsData').child(path)
      ref.once('value', (snapshot) => {
        callback(snapshot.val())
      })
    },
    updateDataByPath (path, newData, callback) {
      let ref = _this.getRef('widgetsData')
      if (path) ref = _this.getRef('widgetsData').child(path)
      ref.set(newData, (err) => {
        if (err) callback(err)
        else callback(null)
      })
    },
    readComputed (callback) {
      _this.getRef('widgetsComputed').on('value', (snapshot) => {
        let data = snapshot.val() || {}
        callback(data)
      })
    },
    update (key, updatedWidget, callback) {
      _this.getRef('widgets').child(key).update(updatedWidget, (err) => {
        if (err) callback(err)
        else callback(null)
      })
    },
    delete (key, dependency, callback) {
      _this.getRef('widgets').child(key).remove(() => {
        if (dependency) {
          _this.getRef('widgetsData').child(dependency).remove()
        }
        callback()
      })
    },
    getUserModels (uid, callback) {
      _this.getRef('userWidgetsData').child(uid)
        .on('value', (snapshot) => {
          callback(snapshot.val())
        })
    },
    setUserModel (uid, modelKey, modelVal, callback) {
      modelKey = modelKey.replace(/\./g, '/')

      _this.getRef('userWidgetsData')
        .child(uid + '/' + modelKey)
        .set(modelVal, () => {
          if (callback) callback()
        })
    },
    createDataWidget (data, callback) {
      let widget = {
        title: data.title,
        dataPath: data.path,
        dataWidget: true,
        gsOptions: {
          x: 0,
          y: 0,
          w: data.w,
          h: data.h
        },
        tab: data.tab
      }

      _this.getRef('widgets').push(widget, () => {
        callback()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/db/widgets.js